import React from "react";
import clap from "../../images/share-icons/clap.png"

const Clap = () => {
    return (
        <div className="clp" >
            <img className="clap" src={clap} alt="clap" /> 9.56k
        </div>
    );
}

export default Clap;